import * as types from "./mutation-type";

export default {
    [types.SET_CATEGORY](state, payload) {
        state.category = payload;
    },
    [types.SET_PRODUCTS](state, payload) {
        state.products = payload;
    },
    [types.SET_PAGINATION](state, payload) {
        state.pagination = payload;
    },
}